import {
    FETCH_USER_DATA,
} from '../ActionTypes'

const API_URL = process.env.API_URL

const updateUserProfile = (json) => {
    return {
        type: FETCH_USER_DATA,
        payload: json
    }
}

export const fetchProfile = (token, cb) => {
    return dispatch => {
        return fetch(`${API_URL}/auth/profile`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`
                }
            })
            .then(response => response.json())
            .then(json => {
                if (json.success) {
                    dispatch(updateUserProfile(json.result))
                    if (cb)
                        cb(json.result)
                }
            })
    }
}

export const updateProfile = (token, userProfile, cb) => {
    return dispatch => {
        return fetch(`${API_URL}/auth/profile`, {
                method: 'PUT',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(userProfile)
            })
            .then(response => response.json())
            .then(json => {
                if (json.success) {
                    dispatch(fetchProfile(token))
                }
                cb(json.success, json.message)
            })
    }
}


// WEBPACK FOOTER //
// ./src/ProfilePage/ProfilePageActions.js